<template>
    <transition name="slide-fade">
        <div class="modal" :class="{ 'open': open }" v-if="open">
            <div class="modal-content">
                <div class="bg-white w-full rounded-xl p-3 text-a-gray-555555 relative">
                    <div class="text-center text-16 font-medium pt-1 pb-6">
                        ยืนยันการแจ้งอุบัติเหตุ
                    </div>
                    <div class="mx-10 mb-3">
                        <a class="block text-center w-full bg-a-orange-fe5000 text-white rounded-full py-2" href="tel:1519">
                            โทร 1519
                        </a>
                    </div>

                    <button type="button" class="outline-none appearance-none bg-none absolute top-2 right-2" @click="clickOk()">
                        <img src="@/assets/icon/ic-close.svg" alt=""/>
                    </button>
                </div>
            </div>
        </div>
    </transition>

    <transition name="fade">
        <div class="modal-backdrop" v-if="open"></div>
    </transition>
</template>
<script>
import LocaleMixin from "@/mixin/LocaleMixin.js";

import Utility from "@/helper/Utility";

export default {
    name: "RedLicensePlateModal",
    mixins: [LocaleMixin],
    props: {
        controller: Object,
    },
    data: function () {
        return {
            open: false,
            title: '',
            message: '',
            modalConfig: null,
            btnOk: 'ปิด',
            busModal: null,
            btnComponent: null
        };
    },
    computed: {
        msgBodyClass: function () {
            if (this.modalConfig != null && !Utility.isEmptyStr(this.modalConfig?.msgClass)) {
                return this.modalConfig.msgClass
            }
            return 'pb-4'
        }
    },
    created: function () {
        this.busModal = this.controller.busModal;
    },
    mounted: function () {
        this.busModal.on('show', this.show);
        this.busModal.on('hide', this.hide);
    },
    watch: {
        '$route.path': function () {
            if (this.open) {
                this.hide();
            }
        },
    },
    methods: {
        show: function (config) {
            this.modalConfig = config
            this.title = config.title
            this.message = config.msg;
            this.btnComponent = config?.btnComponent ?? null
            this.btnOk = config?.btnOk ?? 'ปิด'

            document.body.classList.add('not-scroll');
            this.open = true;
        },
        hide: function () {
            document.body.classList.remove('not-scroll');
            this.open = false;
        },
        clickOk: function () {
            this.hide();
            this.controller.sendCallbackOk();
        },
    },
}
</script>
<style lang="scss" scoped>
@import "@/style/modal.scss";

.modal {
    @extend %modal;
}
</style>
